export type FieldStateColor = { main: string };

export type CorrectIconOption =
  | 'CheckOutlined'
  | 'CheckCircleOutlined'
  | 'CheckCircle';
export type ErrorIconOption =
  | 'CloseOutlined'
  | 'CancelOutlined'
  | 'Cancel'
  | 'ReportProblemOutlined'
  | 'ErrorOutlinedOutlined'
  | 'ErrorOutlined';

export type FieldStates = {
  enabled: boolean;
  focused?: FieldStateColor;
  untouched?: FieldStateColor;
  touched?: FieldStateColor;
  error: FieldStateColor;
  correct: FieldStateColor;
  showCorrectIcon: boolean;
  correctIcon: CorrectIconOption;
  showErrorIcon: boolean;
  errorIcon: ErrorIconOption;
};

export const DEFAULT_FIELD_STATES: FieldStates = {
  enabled: false,
  focused: { main: '#1677ff' },
  untouched: { main: '#929292' },
  touched: { main: '#8c8c8c' },
  error: { main: '#ff4d4f' },
  correct: { main: '#389e0d' },
  showCorrectIcon: false,
  correctIcon: 'CheckOutlined',
  showErrorIcon: false,
  errorIcon: 'CloseOutlined',
};
